namespace HelpCenterJwt {
  const key = 'help_center_jwt';
  export const get = (): string | null => {
    return localStorage.getItem(key);
  };

  export const set = (value: string) => {
    localStorage.setItem(key, value);
  };

  export const clear = () => {
    localStorage.removeItem(key);
  };

}

export default HelpCenterJwt;
